<template>
  <div class="header">
    <div class="bg-container">
      <div class="image-overlay" @click="handleToHome"></div>
      <div class="text-overlay" @click="handleToHome">MEC设备管理平台</div>
    </div>
    <div class="menu-container">
      <div class="mx-4">
        <el-button class="buttons" v-for="button in buttons" :key="button.text" :type="button.type" @click="button.handler" link>{{ button.text }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '../event-bus.js'
import { ElMessageBox } from 'element-plus'

export default {
  name: 'HeaderBar',
  data () {
    return {
      isLogin: false,
      buttons: []
    }
  },
  mounted () {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if (userInfo !== null) {
      this.isLogin = userInfo.isLogin
    } else {
      this.isLogin = false
    }
    const self = this
    eventBus.on('login_success', (isLogin) => {
      self.isLogin = isLogin
      self.loadButtons()
    })
    this.loadButtons()
  },
  methods: {
    loadButtons () {
      if (this.isLogin) {
        this.buttons = [{ type: 'text', text: '首页', handler: this.handleToHome }, { type: 'text', text: '个人中心', handler: this.handleToProfile }, { type: 'text', text: '关于', handler: this.handleToAbout }, { type: 'text', text: '退出登录', handler: this.handleLogout }]
      } else {
        this.buttons = []
      }
    },
    handleToHome () {
      this.$router.push('/main')
    },
    handleToProfile () {
      this.$router.push('/profile')
    },
    handleToAbout () {
      this.$router.push('/about')
    },
    handleLogout () {
      ElMessageBox.confirm('确定退出登录吗? ', '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.requestLogout()
        })
        .catch(() => {

        })
    },
    requestLogout () {
      localStorage.clear()
      this.$store.state.userInfo = null
      this.$router.push('/login')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.header {
  height: 64px;
  width: 100%;
  background: linear-gradient(90deg, #088861, #0D6C4F);
  min-width: 1200px;
}

.bg-container {
  float: left;
  position: relative;
  width: 596px;
  height: 100%;
  background-image: url('@/assets/title_bg.png');
  background-size: cover;
  background-position: center;
  /* background-color: chocolate; */
}

.image-overlay {
  position: absolute;
  width: 32px;
  height: 32px;
  top: 25%;
  left: 12%;
  background-image: url('@/assets/header_logo.png');
}

.text-overlay {
  position: absolute;
  width: 448px;
  top: 47%;
  left: 280px;
  transform: translate(-50%, -50%);
  color: white;
  text-align: center;
  font-family: 'Microsoft YaHei, Microsoft YaHei';
  font-weight: bold;
  font-size: 28px;
  line-height: 33px;
}

.menu-container {
  float: right;
  position: relative;
  width: 448px;
  height: 100%;
  /* background-color: burlywood; */
  display: flex;
  justify-content: end;
  align-items: center;
  padding-right: 16px;
}

.buttons {
  color: white !important;
}

</style>
